import StatusBadge from "../../../../../utils/StatusBadge";

export const roleColumns = [
    { key: "__sn", label: "#" },
    { key: "name", label: "Role", sortable: true },
    { key: "users", label: "Employees", sortable: true },
    { key: "permissionsCount", label: "Permissions", sortable: true },
    {
        key: "status", label: "Status",
        render: (value) => ( <StatusBadge status={value} /> )
    },
];

export const roleData = [
    {
        id: 1,
        name: "Admin",
        description: "Full system access",
        users: 2,
        permissionsCount: 42,
        permissions: [ "Employees", "Departments", "Offices", "Tasks", "Reports", "Settings" ],
        status: "Active",
    },

    {
        id: 2,
        name: "Manager",
        description: "Manage teams and tasks",
        users: 8,
        permissionsCount: 28,
        permissions: [ "Employees", "Tasks", "Departments", "Calendar" ],
        status: "Active",
    },

    {
        id: 3,
        name: "Accountant",
        description: "Day to day accounting work",
        users: 96,
        permissionsCount: 18,
        permissions: [ "Clients", "Invoices", "Tasks", "Calendar" ],
        status: "Active",
    },

    {
        id: 4,
        name: "Intern",
        description: "Limited access",
        users: 12,
        permissionsCount: 7,
        permissions: [ "Tasks", "Calendar" ],
        status: "Inactive",
    },
];
